var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7603 6.9375H4.23968C1.90092 6.9375 0 8.83842 0 11.1772V30.4478C0 32.7866 1.90092 34.6875 4.23968 34.6875H32.7603C35.0991 34.6875 37 32.7866 37 30.4478V11.1772C37 8.83842 35.0991 6.9375 32.7603 6.9375Z",
    fill: "#CCCCCC",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4162 16.9598C15.4162 19.0883 13.6908 20.8139 11.5621 20.8139C9.43335 20.8139 7.70801 19.0883 7.70801 16.9598C7.70801 14.8311 9.43335 13.1055 11.5621 13.1055C13.6908 13.1055 15.4162 14.8311 15.4162 16.9598Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2603 22.3555H8.86468C6.52592 22.3555 4.625 24.2564 4.625 26.5951V27.3661C4.625 28.0043 5.143 28.5223 5.78125 28.5223H17.3438C17.982 28.5223 18.5 28.0043 18.5 27.3661V26.5951C18.5 24.2564 16.5991 22.3555 14.2603 22.3555Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2183 16.1875H22.7393C22.101 16.1875 21.583 15.6695 21.583 15.0312C21.583 14.393 22.101 13.875 22.7393 13.875H31.2183C31.8566 13.875 32.3746 14.393 32.3746 15.0312C32.3746 15.6695 31.8566 16.1875 31.2183 16.1875Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2183 22.3555H22.7393C22.101 22.3555 21.583 21.8375 21.583 21.1992C21.583 20.561 22.101 20.043 22.7393 20.043H31.2183C31.8566 20.043 32.3746 20.561 32.3746 21.1992C32.3746 21.8375 31.8566 22.3555 31.2183 22.3555Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2183 28.5195H22.7393C22.101 28.5195 21.583 28.0015 21.583 27.3633C21.583 26.725 22.101 26.207 22.7393 26.207H31.2183C31.8566 26.207 32.3746 26.725 32.3746 27.3633C32.3746 28.0015 31.8566 28.5195 31.2183 28.5195Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdcard);
export default __webpack_public_path__ + "static/media/idcard.59230cd1.svg";
export { ForwardRef as ReactComponent };